<template>
  <div class="map-wrapper">
    <div class="controls" v-if="controls">
      <button class="map-height" :title="copy.expand" @click="heightToggle">
        <span v-if="!expanded">
          <img :src="expandIcon" :alt="copy.expand" />
          <span>{{ copy.expand }}</span>
        </span>
        <span v-else>
          <img :src="minimizeIcon" :alt="copy.expand" />
          <span>{{ copy.minimize }}</span>
        </span>
      </button>
    </div>
    <gmap-map
      ref="mapRef"
      id="gmap"
      :center="center"
      :zoom="zoomLevel"
      :style="{ height: expanded ? '500px' : '300px' }"
      :options="options"
    >
      <gmap-marker
        :key="index"
        v-for="(marker, index) in markers"
        :position="marker.position"
        :icon="pinImage"
        :animation="4"
        :title="marker.address || 'Location'"
        :clickable="true"
        @click="toggleInfoWindow(marker, index)"
      ></gmap-marker>
      <gmap-info-window
        @closeclick="infoWindow.open = false"
        :opened="infoWindow.open"
        :options="infoWindow.options"
        :position="infoWindow.position"
      >
        <div v-html="infoWindow.content"></div>
      </gmap-info-window>
    </gmap-map>
  </div>
</template>
<script>
/* eslint-disable prettier/prettier, no-console */
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import localize from '../utility/localize';

Vue.use(VueGoogleMaps, {
  load: {
    key: localize('svb_gmap_key') || '',
    language: localize('svb_website_lang') || 'en',
  },
  autobindAllEvents: false,
});

export default {
  props: {
    markers: Array,
    target: String,
    readMoreText: String,
  },
  watch: {
    markers: function (newVal) {
      // watch it
      this.recalculateBounds(newVal);
    },
  },
  data() {
    return {
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: true,
      },
      infoWindow: {
        open: false,
        position: {
          lat: 0,
          lng: 0,
        },
        options: {
          pixelOffset: {
            height: -35,
          },
        },
        content: '',
        currentlyOpen: null,
      },
      copy: {
        expand: localize('expand_label') || 'Bigger map',
        minimize: localize('minimize_label') || 'Smaller map',
        applyChanges: localize('Tillämpa val') || 'Anvend valg',
      },
      center: { lat: 59.2538965, lng: 15.2390413 },
      zoomLevel: localize('zoomLevel') ? parseInt(localize('zoomLevel')) : 5,
      pinImage: localize('marker_image') || '',
      expandIcon: localize('enlarge_full') || '',
      minimizeIcon: localize('enlarge_min') || '',
      controls: false,
      expanded: false,
      attemptMax: 5,
      recalculateBoundsAttempt: 0,
    };
  },
  mounted() {
    if (this.$refs.mapRef) {
      this.$nextTick(() => {
        this.$refs.mapRef.$gmapApiPromiseLazy().then(this.setControlsVisible);
      });
    }
  },
  methods: {
    heightToggle() {
      this.expanded = !this.expanded;
    },
    setControlsVisible() {
      this.controls = true;
    },
    tryAgain(items) {
      var that = this;
      setTimeout(function () {
        that.recalculateBounds(items);
      }, 500);
    },
    recalculateBounds(items) {
      if (!items.length) {
        console.log('!items.length');
        return;
      }

      if (!window.google && this.recalculateBoundsAttempt < this.attemptMax) {
        this.recalculateBoundsAttempt++;
        this.tryAgain(items);
        console.log(
          'Trying to recalculate map bounds, but window.google is not defined, try again in a while...'
        );
        return;
      }

      var bounds = new window.google.maps.LatLngBounds();

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (!item.position) {
          continue;
        }

        var coordinates = new window.google.maps.LatLng(
          item.position.lat,
          item.position.lng
        );

        bounds.extend(coordinates);
      }

      this.center = bounds.getCenter();

      var listenerHandle = this.$refs.mapRef.$mapObject.addListener(
        'zoom_changed',
        () => {
          let mapZoom = this.$refs.mapRef.$mapObject.getZoom();
          if (mapZoom > this.zoomLevel) {
            this.$refs.mapRef.$mapObject.setZoom(this.zoomLevel);
          }
          window.google.maps.event.removeListener(listenerHandle);
        }
      );

      this.$refs.mapRef.fitBounds(bounds, 0);
    },
    toggleInfoWindow(marker, index) {
      this.infoWindow.position = marker.position;
      this.infoWindow.content = this.getInfoWindowContent(marker);
      if (this.infoWindow.currentlyOpen == index) {
        this.infoWindow.open = !this.infoWindow.open;
      } else {
        this.infoWindow.open = true;
        this.infoWindow.currentlyOpen = index;
      }
    },

    getInfoWindowContent(marker) {
      var html = '';

      html += '<div class="ssws-info-outer ssws1-results">';
      html += '<div aria-hidden="true" class="info-image-sec">';
      html +=
        '<img aria-hidden="true" src="' +
        marker.image +
        '" alt="" class="info-image"/>';
      html += '</div>';
      html += '<div aria-hidden="true" class="above-info-title">';
      html += '<span aria-hidden="true">' + marker.tjanst + '</span>';
      html += '</div>';
      html += '<div aria-hidden="true" class="info-title">';
      html += '<span aria-hidden="true">' + marker.postTitle + '</span>';
      html += '</div>';
      html += '<div aria-hidden="true" class="info-group">';
      html += '<span aria-hidden="true">' + marker.malgrupp + '</span>';
      html += '</div>';
      html += '<div class="info-btn-sec">';
      html +=
        '<a  aria-live="off" aria-label=" " class="read-more" href="' +
        marker.permalink +
        '" ';
      if (this.target === 'blank') {
        html += 'target="_blank"';
      }
      html += '>';
      html += this.readMoreText;
      html += '</a>';
      html += '</div>';
      html += '</div>';

      return html;
    },
  },
};
</script>
<style lang="css">
#gmap {
  width: 100%;
}
.map-wrapper {
  position: relative;
}
.controls {
  z-index: 1;
  position: absolute;
  right: 60px;
  top: 0px;
}
.controls button {
  background-color: #fff;
  border: none;
  outline: none;
  border-radius: 2px;
  box-shadow: rgba(128, 119, 119, 0.3) 0px 0px 1px 1px;
  margin-top: 10px;
  cursor: pointer;
  padding: 10.5px 15px;
  font-size: 12px;
}
.controls button img {
  height: 18px;
  margin-right: 10px;
}
</style>
